/* unplugin-vue-components disabled */import script from "./proto-pagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./proto-pagination.vue?vue&type=script&setup=true&lang=ts"

import "./proto-pagination.vue?vue&type=style&index=0&id=f2667a1a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2667a1a"]])

export default __exports__